import {
  BOOKS_BOOK_REVIEW_SET_DATA,
  BOOKS_BOOK_REVIEW_RESET_DATA,
} from 'rebook/apps/books/constants';


const initialState = {
  review: null,
};

export default function bookReview(state = initialState, action) {
  switch (action.type) {
    case BOOKS_BOOK_REVIEW_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case BOOKS_BOOK_REVIEW_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
